import { diYu } from './common-var'

const fieldsAll = {
  基本信息: {
    title: '基本信息',
    fields: {
      姓名: {
        label: '姓名',
        width: '32%',
        isRequired: true,
      },
      英文名: {
        label: '英文名',
        width: '32%',
      },
      长期意向: {
        label: '长期意向',
        width: '32%',
        type: 'color',
        options: {
          Y: { word: 'Y.积极看机会', color: '#f99' },
          N: { word: 'N.暂时不看机会', color: '#ffc' },
          F: { word: 'F.再跟进', color: '#ccf' },
        },
      },
      手机: {
        label: '手机',
        width: '32%',
      },
      性别: {
        label: '性别',
        width: '32%',
        type: 'select',
        options: ['男', '女'],
      },
      婚育: {
        label: '婚育',
        width: '32%',
        type: 'select',
        options: ['未婚', '已婚未育', '已婚已育', '其他'],
      },
      籍贯: {
        label: '籍贯',
        width: '32%',
      },
      出生年月: {
        label: '出生年月',
        width: '32%',
        displayLabel: '例:1980.01',
        // type: 'month'
      },
      职能模块: {
        label: '职能模块',
        width: '32%',
        type: 'multSelect',
        options: [],
      },
      细分职能: {
        label: '细分职能',
        width: '32%',
        type: 'createSelect',
        option: [],
      },
      擅长方向: {
        label: '擅长方向',
        width: '32%',
        type: 'multSelect',
        option: [],
      },
      职级: {
        label: '职级',
        width: '32%',
        type: 'select',
        options: {
          '1': '1.高管',
          '2': '2.部门总',
          '3': '3.部门副总/总助/团队长',
          '4': '4.部门核心骨干',
          '5': '5.新人三年以下',
        },
      },
      业绩: {
        label: '业绩',
        width: '32%',
        type: 'select',
        options: { aaa: 'aaa.领军人物', aa: 'aa.卓越人选', a: 'a.优秀人选', b: 'b.良好', c: 'c.一般', d: 'd.较差' },
      },
      平台: {
        label: '平台',
        width: '32%',
        type: 'select',
        options: {
          A: 'A.大平台',
          B: 'B.中平台',
          C: 'C.小平台',
        },
      },
      地域: {
        label: '地域',
        width: '32%',
        type: 'createSelect',
        options: diYu,
      },
      公司: {
        label: '公司',
        width: '32%',
      },
      曾任职公司: {
        label: '曾任职公司',
        width: '32%',
      },
      部门: {
        label: '部门',
        width: '32%',
      },
      组别: {
        label: '组别',
        width: '32%',
      },
      目前职位: {
        label: '目前职位',
        width: '32%',
      },
      专业职级: {
        label: '专业职级',
        width: '32%',
        type: 'autocomplete',
        options: ['ManagingPartner', 'Partner', 'MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN'],
      },
      管理职级: {
        label: '管理职级',
        width: '32%',
        type: 'autocomplete',
        options: [
          '公司总经理',
          '公司副总',
          '公司总助',
          '一级部门总',
          '二级部门总',
          '部门副总',
          '部门总助',
          '总监',
          '副总监',
          '经理',
          '主管',
          '专员',
        ],
      },
      薪酬机制: {
        label: '薪酬机制',
        width: '32%',
      },
      本科院校: {
        label: '本科院校',
        width: '32%',
      },
      硕士院校: {
        label: '硕士院校',
        width: '32%',
      },
      学历: {
        label: '学历',
        width: '32%',
        type: 'select',
        options: ['中专', '大专', '本科', '硕士', '博士', '博士后'],
      },
      下属个数: {
        label: '下属个数',
        width: '32%',
      },
      汇报上级: {
        label: '汇报上级',
        width: '32%',
      },
      行业: {
        label: '行业',
        width: '32%',
        type: 'select',
        options: [],
      },
      从业起始年: {
        label: '从业起始年',
        width: '32%',
      },
      个性标签: {
        label: '个性标签',
        width: '32%',
      },
      规模: {
        label: '规模',
        width: '32%',
      },
      管理基金数量: {
        label: '管理基金数量',
        width: '32%',
      },
      任职期: {
        label: '任职期',
        width: '32%',
      },
      管理基金: {
        label: '管理基金',
        width: '32%',
      },
      投资风格: {
        label: '投资风格',
        type: 'select',
        options: ['GARP型', '价值型', '成长型', '极致成长型', '综合型'],
        width: '32%',
      },
      香港牌照: {
        label: '香港牌照',
        width: '32%',
        type: 'multSelect',
        options: [
          '证券交易',
          '期货合约交易',
          '杠杆式外汇交易',
          '就证券提供意见',
          '就期货合约提供意见',
          '就机构融资提供意见',
          '提供自动化交易服务',
          '提供证券保证金融资',
          '提供资产管理',
          '提供信贷评级服务',
        ],
      },
      获奖经历: {
        label: '获奖经历',
        width: '32%',
        type: 'multSelect',
        options: ['新财富', '金牛奖', '水晶球', '麒麟奖', '英华奖'],
      },
      简介: {
        label: '简介',
        width: '100%',
        type: 'textarea',
      },
    },
  },
  联系方式: {
    title: '其他联系方式',
    fields: {
      座机: {
        label: '座机',
        width: '49%',
      },
      邮箱: {
        label: '邮箱',
        width: '49%',
      },
      微信: {
        label: '微信',
        width: '49%',
      },
      其他: {
        label: '其他',
        width: '49%',
      },
    },
  },
  意向: {
    title: '意向',
    fields: {
      期望行业: {
        label: '期望行业',
        width: '24%',
        type: 'multSelect',
        options: [],
      },
      期望地域: {
        label: '期望地域',
        width: '24%',
        type: 'createSelect',
        options: diYu,
      },
      期望固薪: {
        label: '期望固薪',
        width: '24%',
      },
      期望奖金: {
        label: '期望奖金',
        width: '24%',
      },
    },
  },
  其他: {
    title: '其他标签',
    fields: {
      学历标签: {
        label: '学历标签',
        type: 'checkbox',
        options: [
          '常青藤',
          '清北交复',
          '985',
          '211',
          '海外背景',
          'QS100',
          'TIMES100',
          '理工科',
          '财务',
          '法务',
          '金融',
          '医药医疗',
          '微电子',
          '计算机',
          '中金line',
          '中信line',
          '建投line',
          '广发学历',
          '前海开源line',
        ],
      },
      语言标签: {
        label: '语言标签',
        type: 'checkbox',
        options: [
          '英文-1-母语水平',
          '英文-2-工作语言',
          '英文-3-可顺利读写，口语较弱',
          '粤语',
          '日语',
          '法语',
          '小语种',
        ],
      },
      职业资格: {
        label: '职业资格',
        type: 'checkbox',
        options: [
          '保代',
          '准保',
          '保代A类',
          '保代B类',
          '保代C类',
          '基金从业资格',
          '证券从业资格',
          'CFA',
          'CPA',
          'FRM',
          '律师执业资格',
          '法律从业资格',
          'REITs基金经理从业资格',
          '期货从业资格',
          '银行从业资格',
          'CIA（审计师）',
          'ACCA（国际注册会计师）',
          'CMA（美国注册管理会计师）',
          'CISA（信息系统审计师）',
          'CTA（税务师）',
          'SOA（北美保险精算师）',
          'CAA（保险精算师）',
        ],
      },
      语言能力: {
        label: '语言能力',
        type: 'textarea',
      },
      证书: {
        label: '证书',
        type: 'textarea',
      },
      个性标签: {
        label: '个性标签',
        type: 'textarea',
        width: '100%',
      },
    },
  },
}
const fieldsExp = {
  教育: {
    title: '教育经历',
    fields: {
      起始时间: {
        label: '起始时间',
        width: '49%',
        type: 'month',
      },
      结束时间: {
        label: '结束时间',
        width: '49%',
        type: 'month',
      },
      学校: {
        label: '学校',
        width: '100%',
      },
      专业: {
        label: '专业',
        width: '49%',
      },
      学历: {
        label: '学历',
        width: '49%',
        type: 'select',
        options: ['中专', '大专', '本科', '硕士', '博士', '博士后'],
      },
    },
  },
  工作: {
    title: '工作经历',
    fields: {
      公司: {
        label: '公司',
        width: '49%',
      },
      当前公司: {
        label: '当前公司',
        type: 'switch',
        width: '49%',
      },
      起始时间: {
        label: '起始时间',
        width: '49%',
        type: 'month',
      },
      结束时间: {
        label: '结束时间',
        width: '49%',
        type: 'month',
      },
      部门: {
        label: '部门',
        width: '33%',
      },
      组别: {
        label: '组别',
        width: '33%',
      },
      目前职位: {
        label: '目前职位',
        width: '33%',
      },
      管理职级: {
        label: '管理职级',
        width: '33%',
        type: 'autocomplete',
        options: [
          '公司总经理',
          '公司副总',
          '公司总助',
          '一级部门总',
          '二级部门总',
          '部门副总',
          '部门总助',
          '总监',
          '副总监',
          '经理',
          '主管',
          '专员',
        ],
      },
      专业职级: {
        label: '专业职级',
        width: '33%',
        type: 'autocomplete',
        options: ['ManagingPartner', 'Partner', 'MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN'],
      },
      下属人数: {
        label: '下属人数',
        width: '33%',
      },
      汇报上级: {
        label: '汇报上级',
        width: '33%',
      },
      固薪: {
        label: '固薪',
        width: '33%',
      },
      奖金: {
        label: '奖金',
        width: '33%',
      },
      工作描述: {
        label: '工作描述',
        type: 'textarea',
      },
      工作职责: {
        label: '工作职责',
        type: 'textarea',
      },
      工作业绩: {
        label: '工作业绩',
        type: 'textarea',
      },
    },
  },
  项目: {
    title: '项目经历',
    fields: {
      起始时间: {
        label: '起始时间',
        width: '49%',
        type: 'month',
      },
      结束时间: {
        label: '结束时间',
        width: '49%',
        type: 'month',
      },
      项目名称: {
        label: '项目名称',
        width: '49%',
      },
      公司: {
        label: '公司',
        width: '49%',
      },
      项目职务: {
        label: '项目职务',
        width: '49%',
      },
      项目描述: {
        label: '项目描述',
        type: 'textarea',
      },
      项目职责: {
        label: '项目职责',
        type: 'textarea',
      },
      项目业绩: {
        label: '项目业绩',
        type: 'textarea',
      },
    },
  },
}

const fieldsEs = [
  {
    label: '简介',
    field: '简介',
  },
  {
    label: '沟通日志',
    field: '沟通日志',
  },
  {
    label: '旧系统沟通备注',
    field: '旧系统沟通备注',
  },
  {
    label: '职能模块',
    field: '职能模块',
  },
  {
    label: '细分职能',
    field: '细分职能',
  },
  {
    label: '个性标签',
    field: '个性标签',
  },
  {
    label: '擅长方向',
    field: '擅长方向',
  },
  {
    label: '行业',
    field: '行业',
  },
  {
    label: '部门',
    field: '部门',
  },
  {
    label: '组别',
    field: '组别',
  },
  {
    label: '目前职位',
    field: '目前职位',
  },
  {
    label: '姓名',
    field: '姓名^5',
  },
  {
    label: '英文名',
    field: '英文名',
  },
  {
    label: '地域',
    field: '地域',
  },
  {
    label: '平台',
    field: '平台',
  },
  {
    label: '职级',
    field: '职级',
  },
  {
    label: '业绩',
    field: '业绩',
  },
  {
    label: '性别',
    field: '性别',
  },
  {
    label: '婚育',
    field: '婚育',
  },
  {
    label: '籍贯',
    field: '籍贯',
  },
  {
    label: '公司',
    field: '公司^5',
  },
  {
    label: '曾任职公司',
    field: '曾任职公司',
  },
  {
    label: '管理职级',
    field: '管理职级',
  },
  {
    label: '专业职级',
    field: '专业职级',
  },
  {
    label: '学历',
    field: '学历',
  },
  {
    label: '学历标签',
    field: '学历标签',
  },
  {
    label: '语言标签',
    field: '语言标签',
  },
  {
    label: '职业资格',
    field: '职业资格',
  },
  {
    label: '香港牌照',
    field: '香港牌照',
  },
  {
    label: '投资风格',
    field: '投资风格',
  },
  {
    label: '学校',
    field: '*院校',
  },
]
export { fieldsAll, fieldsExp, fieldsEs }
